export const canProductUseCareBalance = (productId, allowedProductIds = "") => {
  allowedProductIds =
    allowedProductIds ||
    process.env?.REACT_APP_ALLOW_THESE_PRODUCT_IDS_TO_USE_CARE_BALANCE;

  const productIds = allowedProductIds?.split(",")?.map((item) => +item) || [];

  return productIds.includes(productId);
};
